import { styled, x } from '@xstyled/styled-components';
import React from 'react';
import { t } from 'ttag';
import { CloseButton } from '~/ui/buttons/CloseButton';
import { Flex } from '~/ui/flex/Flex';
import { HelpPages, useHelpStore } from '../Store';
import { IssueForm } from './IssueForm';

const HelpBody = styled(Flex)`
  height: auto;
  min-height: 0;
`;

export const ConfidentialHotline = () => {
  const { page, setPage } = useHelpStore();

  if (page !== HelpPages.ConfidentialHotline) return null;

  return (
    <>
      <CloseButton onClick={() => setPage(HelpPages.Root)} />
      <HelpBody variant="list" gap="20px">
        <x.h2 id="help-hotline-title" fontFamily="llama" ml="30px">
          {t`Write a message`}
        </x.h2>
        <x.div maxW="330px">{t`Submit your concerns to the HR department or company admin.
  Report any potential ethics violations, harassment, fraud, etc.`}</x.div>
        <IssueForm recipient="company" />
      </HelpBody>
    </>
  );
};
